// Datan laatu — building scope renders the live data-quality summary + Signaalit
// workspace directly, no Yhteenveto/Havainnot/Tapahtumaloki topic tabs.
// Owns Finding.category = "data_quality"; Signaalit is the one live-signal home
// in the IA.
import { Radio } from "lucide-react";
import { DataPointsExplorer } from "@/components/building/datapoints/DataPointsExplorer";
import { SectionPanel } from "@/components/ui/section-panel";
import { LensTopicSection } from "./LensTopicSection";
import { DATA_QUALITY_FINDINGS_FILTER } from "./lens-topic-metrics";

export function DataQualitySection() {
  return (
    <LensTopicSection
      eyebrow="Datan laatu · näkymä"
      title="Onko mittausdata luotettavaa"
      description="Signaalien laatu ja luotettavuus · data-laaturata."
      tracks={[
        {
          id: "data_quality",
          filter: DATA_QUALITY_FINDINGS_FILTER,
          label: "Datan laatu",
          summaryOptions: {
            okHint: "ei avoimia datahavaintoja",
            openHint: "avoimia datahavaintoja",
          },
          activityCategories: ["Konfiguraatio", "Analytiikka"],
          defaultEntityKind: "signal",
          findingsList: {
            ...DATA_QUALITY_FINDINGS_FILTER,
            emptyMessage: "Ei avoimia data-laatuhavaintoja.",
          },
          subHeaderSuffix: "datan laatu",
          overviewCopy: {
            situationCardSubtitle: (count) =>
              count === 1
                ? "1 kiinteistössä avoimia datahavaintoja"
                : `${count} kiinteistössä avoimia datahavaintoja`,
            situationCardAllDoneLabel: "Ei avoimia datahavaintoja",
            emptyScopeHint: "Ei kiinteistöjä valitulla rajauksella",
            tileCompleteLabel: "Kunnossa",
            mapTitle: "Datan laadun kartta",
            mapSubtitle:
              "Missä on eniten avoimia datahavaintoja — pallon koko = kiinteistöjä joilla on avoimia havaintoja",
            mapLegendOkLabel: "Kunnossa",
            mapLegendWarnLabel: "Avoimia havaintoja",
          },
        },
      ]}
      renderSummaryPanel={(buildingId) => (
        <SectionPanel
          icon={Radio}
          title="Signaalit"
          subtitle="Kaikki signaalit · elävät arvot, tuoreus ja lähteet"
        >
          <DataPointsExplorer buildingId={buildingId} />
        </SectionPanel>
      )}
    />
  );
}
